export const passouGanhouMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 1558,
                "codigoVendedor": "277574",
                "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO",
                "basesPassouGanhou": [
                    {
                        "id": 1,
                        "campanhaPassouGanhous": [
                            {
                                "inicioMes": "2025-11-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 1,
                                "transicionouNaoBateu": 8
                            },
                            {
                                "inicioMes": "2025-12-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 5,
                                "transicionouNaoBateu": 6
                            },
                            {
                                "inicioMes": "2026-01-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 4,
                                "transicionouNaoBateu": 4
                            },
                            {
                                "inicioMes": "2026-02-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 4
                            },
                            {
                                "inicioMes": "2026-03-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 4
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 4
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 1,
                                "transicionouNaoBateu": 5
                            }
                        ]
                    },
                    {
                        "id": 2,
                        "campanhaPassouGanhous3x": [
                            {
                                "inicioMes": "2025-11-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 2,
                                "transicionouNaoBateu": 1
                            },
                            {
                                "inicioMes": "2025-12-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 0
                            },
                            {
                                "inicioMes": "2026-01-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 0
                            },
                            {
                                "inicioMes": "2026-02-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 2,
                                "transicionouNaoBateu": 1
                            },
                            {
                                "inicioMes": "2026-03-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 2,
                                "transicionouNaoBateu": 1
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 3,
                                "transicionouNaoBateu": 1
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "naoTransicionaram": 0,
                                "bateramMeta": 2,
                                "transicionouNaoBateu": 1
                            }
                        ]
                    },
                    {
                        "id": 3,
                        "cardPassouGanhou": {
                            "clientesCampanha": 11,
                            "clientesBateramMeta": 8,
                            "tpvTotalCampanha": 2131684.959999913,
                            "beneficioPeriodo": 18819.76123700009
                        }
                    },
                    {
                        "id": 4,
                        "cardPassouGanhou3x": {
                            "clientesCampanha": 5,
                            "clientesBateramMeta": 4,
                            "tpvTotalCampanha": 2178170.5999999484,
                            "beneficioPeriodo": 20337.769032999935
                        }
                    },
                    {
                        "id": 5,
                        "topBandeirasCashback": [
                            {
                                "bandeira": "Maestro",
                                "transacao": 7745
                            },
                            {
                                "bandeira": "MasterCard",
                                "transacao": 6444
                            },
                            {
                                "bandeira": "Visa Electron",
                                "transacao": 5781
                            },
                            {
                                "bandeira": "BACEN",
                                "transacao": 5569
                            },
                            {
                                "bandeira": "Visa",
                                "transacao": 4662
                            }
                        ]
                    },
                    {
                        "id": 6,
                        "topClientesTransacaoVlozDto": [
                            {
                                "codigo": "1005470",
                                "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                                "transacao": 1583862.8500000031
                            },
                            {
                                "codigo": "1004390",
                                "razaoSocial": "VALENTIM COMERCIO DE MATERIAIS PARA",
                                "transacao": 821617.0600000154
                            },
                            {
                                "codigo": "1005483",
                                "razaoSocial": "CEREJEIRAS DEPOSITO DE MATERIAIS",
                                "transacao": 481137.00000000105
                            },
                            {
                                "codigo": "1598715",
                                "razaoSocial": "ZUM EXPRESS E-COMMERCE LTDA",
                                "transacao": 420516.8500000001
                            },
                            {
                                "codigo": "1750627",
                                "razaoSocial": "DML & ELETRICA MADEIREIRA LTDA",
                                "transacao": 395371.71000000543
                            }
                        ]
                    },
                    {
                        "id": 7,
                        "createdAt": "2026-05-19T14:20:27.7200311"
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]]